import { ApolloClient, InMemoryCache } from '@apollo/client';

import { reactRichComponentsConfig, ServiceType } from './react-rich-components-config';

export class GraphQLResolver {
  constructor(private serviceType: ServiceType) {}

  resolve() {
    const client = new ApolloClient({
      uri: reactRichComponentsConfig.serviceUrls[this.serviceType],
      cache: new InMemoryCache(),
      headers: {
        'X-CSRF-Token': this.getCookie('csrf_token') ?? '',
      },
    });

    return client;
  }

  private getCookie(name: string): string | null {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop()?.split(';').shift() || null;
    return null;
  }
}
